import { supabase } from '@/core/database/supabase';
import { flattenPermissionCatalog, normalizePermissionsJson, permissionJsonToKeys } from '@/modules/settings/permissions/catalog/permissionCatalog';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { RoleDetail, RolePermissionDetail } from '../types/rolesDetail.types';

type Row = Record<string, any>;

const catalogMap = new Map(flattenPermissionCatalog().map((item) => [item.key, item]));

function mapPermission(key: string): RolePermissionDetail {
  const catalog = catalogMap.get(key);
  if (catalog) {
    return {
      key,
      moduleName: catalog.module.name,
      resourceName: catalog.resource.name,
      actionName: catalog.action.name,
      description: catalog.action.description,
      risk: catalog.action.risk,
      scopes: catalog.action.scopes,
    };
  }

  return {
    key,
    moduleName: key.split('.')[0] || 'Khác',
    resourceName: key.split('.')[1] || 'Chung',
    actionName: key.split('.').slice(2).join('.') || key,
    description: 'Quyền tùy chỉnh từ dữ liệu hiện có.',
    risk: 'Vừa',
    scopes: ['Công ty'],
  };
}

export const rolesDetailService = {
  async getRoleById(id: string): Promise<RoleDetail> {
    await enforceSettingsPermission('settings.roles.view');
    const { data: role, error: roleError } = await supabase
      .from('roles')
      .select('*')
      .eq('id', id)
      .single();

    if (roleError) throw roleError;
    const row = role as Row;

    const { data: members, error: membersError } = await supabase
      .from('user_profiles')
      .select('id')
      .eq('role_code', row.code);

    if (membersError) throw membersError;

    const permissionsJson = normalizePermissionsJson(row.permissions_json);
    const keys = permissionJsonToKeys(permissionsJson);
    const permissions = keys.map(mapPermission);

    return {
      id: String(row.id),
      code: String(row.code || ''),
      name: String(row.name || ''),
      description: String(row.description || ''),
      isSystem: Boolean(row.is_system),
      memberCount: (members || []).length,
      permissionCount: permissions.length,
      highRiskCount: permissions.filter((permission) => permission.risk === 'Cao' || permission.risk === 'Rất cao').length,
      permissionsJson,
      permissions,
      createdAt: row.created_at || null,
    };
  },
};
